import script from "./sport-live-tv-player-header.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-player-header.vue?vue&type=script&setup=true&lang=js"

import "./sport-live-tv-player-header.vue?vue&type=style&index=0&id=138efdbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-138efdbe"]])

export default __exports__